import { render, staticRenderFns } from "./BoxDetail.vue?vue&type=template&id=e38b0f6a&"
import script from "./BoxDetail.vue?vue&type=script&lang=js&"
export * from "./BoxDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports